import { THEME_SETTINGS } from "@theme-settings";
import { observable, action } from "mobx";

export class MaintenanceStore {
	private readonly startTime: Date = new Date("2025-04-29T03:00:00Z");
	private readonly endTime: Date = new Date("2025-04-29T07:00:00Z");

	public readonly messageKey: string = "MAINTENANCE.OASIS_MESSAGE";

	private readonly checkIntervalMs: number = 60 * 1000;
	private timerId: number | null = null;

	@observable
	public isVisible = false;

	constructor() {}

	public onInitialize(): void {
		if (this.timerId !== null) return;

		if (!THEME_SETTINGS.isMaintenanceEnabled) {
			this.isVisible = false;
			return;
		}

		const now = new Date();

		if (now > this.endTime) {
			this.isVisible = false;
			return;
		}

		this.checkVisibility();
		this.startTimer();
	}

	@action
	private checkVisibility(): void {
		if (!THEME_SETTINGS.isMaintenanceEnabled) {
			this.isVisible = false;
			return;
		}

		const now = new Date();

		if (now > this.endTime) {
			this.isVisible = false;
			this.stopTimer();
			return;
		}

		this.isVisible = now >= this.startTime;
	}

	private startTimer(): void {
		if (this.timerId !== null) return;

		this.timerId = window.setInterval(() => {
			this.checkVisibility();
		}, this.checkIntervalMs);
	}

	private stopTimer(): void {
		if (this.timerId !== null) {
			clearInterval(this.timerId);
			this.timerId = null;
		}
	}

	public onDispose(): void {
		if (this.timerId !== null) {
			this.stopTimer();
		}
	}
}
